<template>
  <div>
    <v-container fluid class="py-6">
      <div class="d-sm-flex justify-between">
        <v-btn
            @click="companyUpload = true"
            elevation="0"
            :ripple="false"
            height="43"
            class="
            font-weight-bold
            text-uppercase
            btn-default
            bg-gradient-secondary
            py-2
            px-6
            me-2
            mb-sm-0 mb-2
          "
            color="#5e72e4"
            small
        >UPLOAD NEW</v-btn
        >
        <div class="d-flex ms-auto" v-if="false">
          <v-menu transition="slide-y-transition" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                  font-weight-bold
                  text-uppercase
                  btn-default btn-outline-default
                  py-2
                  px-6
                  me-2
                "
                  color="transparent"
                  small
              >
                Filter By
                <v-icon>ni ni-bold-down text-xs ms-1</v-icon>
              </v-btn>
            </template>

            <v-list class="py-0">
              <v-list-item class="list-item-hover-active py-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Approved
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Pending
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Rejected
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <hr class="horizontal dark" />
              <v-list-item class="list-item-hover-active py-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-danger ls-0 font-weight-600 mb-0"
                  >
                    Remove Filter
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              class="
              font-weight-bold
              text-uppercase
              btn-default btn-outline-default
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon>ni ni-archive-2 me-1</v-icon>
            Export CSV
          </v-btn>
          <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              class="
              font-weight-bold
              text-uppercase
              btn-default btn-outline-default
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon>ni ni-archive-2 me-1</v-icon>
            Export PDF
          </v-btn>
        </div>
      </div>
      <v-row>
        <v-col cols="12">
          <v-card class="card-shadow border-radius-xl">
            <div>
              <v-card class="card-shadow border-radius-xl mt-6">
                <v-card-text class="px-0 py-0">
                  <v-data-table
                      :headers="headers"
                      :items="companies"
                      :search="search"
                      class="table"
                      :page.sync="page"
                      hide-default-footer
                      @page-count="pageCount = $event"
                      :items-per-page="itemsPerPage"
                      mobile-breakpoint="0"
                  >
                    <template v-slot:top>
                      <v-toolbar flat height="80">
                        <v-row>
                          <v-col cols="12" md="5">
                            <v-text-field
                                hide-details
                                class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                                dense
                                flat
                                filled
                                solo
                                height="43"
                                v-model="search"
                                placeholder="Search"
                            >
                              <template slot="prepend-inner">
                                <v-icon color="#adb5bd" size=".875rem"
                                >fas fa-search</v-icon
                                >
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-toolbar>
                    </template>

                    <template v-slot:item.id="{ item }">
                      <div class="d-flex align-center">
                        <v-checkbox
                            :ripple="false"
                            v-model="item.checkbox"
                            color="#141727"
                        ></v-checkbox>
                        <span class="my-2 text-xs text-body font-weight-bold">{{
                            item.id
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.period="{ item }">
                    <span class="my-2 text-xs text-body font-weight-bold">{{
                        item.date_of_registration
                      }}</span>
                    </template>

                    <template v-slot:item.trading_as="{ item }">
                    <span class="my-2 text-xs text-body font-weight-bold">{{
                        item.trading_as
                      }}</span>
                    </template>

                    <template v-slot:item.business_address="{ item }">
                    <span class="my-2 text-xs text-body font-weight-bold">{{
                        item.business_address
                      }}</span>
                    </template>

                    <template v-slot:item.telephone="{ item }">
                    <span class="my-2 text-xs text-body font-weight-bold">{{
                        item.telephone
                      }}</span>
                    </template>

                    <template v-slot:item.status="{ item }">
                      <div class="d-flex align-center">
                        <v-btn
                            :ripple="false"
                            icon
                            outlined
                            rounded
                            width="25px"
                            height="25px"
                            class="me-2"
                            :class="
                  item.statusIcon == 'fas fa-check'
                    ? 'border-success'
                    : 'border-warning'
                "
                        >
                          <v-icon
                              size="8"
                              :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'text-success'
                      : 'text-warning'
                  "
                          >
                            {{ item.statusIcon }}
                          </v-icon>
                        </v-btn>
                        <span class="text-body text-xs">{{ item.status }}</span>
                      </div>
                    </template>

                    <template v-slot:item.customer="{ item }">
                      <div class="d-flex align-center">
                        <v-avatar size="24" class="me-2" v-if="item.customerImg">
                          <v-img :src="item.customerImg"></v-img>
                        </v-avatar>

                        <v-avatar size="24" class="me-2 bg-gradient-default" v-else>
                          <span class="text-white text-xs">{{ item.customer[0] }}</span>
                        </v-avatar>
                        <span class="text-body text-xs font-weight-bold">{{
                            item.customer
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.product="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.product
              }}</span>
                    </template>

                    <template v-slot:item.revenue="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.revenue
              }}</span>
                    </template>

                    <template v-slot:item.action="{ item }">
                      <v-btn
                          @click="goTo()"
                          elevation="0"
                          small
                          :ripple="false"
                          height="21"
                          class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                  "
                          :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                      >{{item.statusIcon == 'fas fa-check'
                          ? 'View'
                          : 'View'}}</v-btn
                      >
                    </template>

                    <template v-slot:item.invoice="{ item }">
                      <v-btn
                          color="#fff"
                          class="text-dark font-weight-bolder px-1 shadow-0"
                          small
                          simple
                      >
                        <v-icon size="18" class="rotate-180"
                        >fas fa-file-pdf text-lg me-1</v-icon
                        >
                        Pdf
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions class="card-padding">
                  <v-row>
                    <v-col cols="6" lg="3" class="d-flex align-center">
                      <span class="text-body me-3 text-sm">Items per page:</span>
                      <v-text-field
                          hide-details
                          type="number"
                          outlined
                          min="-1"
                          max="15"
                          background-color="rgba(255,255,255,.9)"
                          color="rgba(0,0,0,.6)"
                          light
                          :value="itemsPerPage"
                          @input="itemsPerPage = parseInt($event, 10)"
                          placeholder="Items per page"
                          class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" class="ml-auto d-flex justify-end">
                      <v-pagination
                          prev-icon="fa fa-angle-left"
                          next-icon="fa fa-angle-right"
                          class="pagination"
                          color="#cb0c9f"
                          v-model="page"
                          :length="pageCount"
                          circle
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog
          v-model="companyUpload"
          persistent
          width="40%"
      >
        <v-card>
          <v-toolbar
              dark
              color="primary"
          >
            <v-btn
                icon
                dark
                @click="companyUpload = false"
            >
              <v-icon color="#adb5bd" size=".875rem">mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-center">
              Upload Companies
            </v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <div class="text-center justify-center">
            <br>
            <h2>
              Select File to upload
            </h2>
            <v-row class="mr-2 ml-2 pt-0 pb-0">
              <v-col
                  sm="12"
                  md="12"
                  lg="12"
              >
                <v-card-actions
                    class="justify-center"
                >

                  <v-file-input
                      @change="PreviewFile"
                      v-model="files"
                      placeholder="Upload your documents"
                      label="File input"
                      multiple
                      prepend-icon="mdi-paperclip"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip
                          small
                          label
                          class="bg-gradient-success"
                      >
                        {{ text }} &nbsp; - {{ companies.length }} Companies
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-card-actions>
              </v-col>
              <v-col
                  sm="12"
                  md="12"
                  lg="12"
              >
                <v-card-actions
                    class="justify-center"
                >
                  <v-btn
                      color="primary"
                      @click="UploadOrgs"
                      class="
                        font-weight-bold
                        text-uppercase
                        btn-default
                        bg-gradient-secondary

                        px-6
                        me-2
                        mb-sm-0 mb-2
                      "
                  >
                    Upload
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="successDialog"
          max-width="290"
          persistent
      >
        <v-card class="text-center ">
          <v-card-title class="text-h5 justify-center">
            Success
          </v-card-title>

          <v-card-text>
            Your upload has been done
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn
                color="green darken-1"
                text
                outlined
                @click="goTo()"
            >
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="errorDialog"
          max-width="290"
          persistent
      >
        <v-card class="text-center ">
          <v-card-title class="text-h5 justify-center">
            Error
          </v-card-title>

          <v-card-text>
            There was an error adding your companies. Please check if all rows have the <b>company name</b> and <b>registration number</b>.
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn
                color="danger darken-1"
                text
                outlined
                @click="errorDialog = false, clear()"
            >
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="text-center">
        <v-overlay :value="overlay">
          <v-progress-circular
              indeterminate
              size="64"
          />
        </v-overlay>
      </div>
    </v-container>
  </div>
</template>
<script>

import axios from "axios";
import {mapState} from "vuex";
import * as XLSX from "xlsx";
import moment from "moment";
import {len} from "vuelidate/lib/validators/common";

export default {
  name: "Returns-List",
  data() {
    return {
      page: 1,
      overlay: false,
      companyUpload: false,
      pageCount: 0,
      itemsPerPage: 10,
      returns: [],
      companies: [],
      successDialog: false,
      errorDialog: false,
      files:[],
      search: "",
      headers: [
        {
          text: "Id",
          align: "start",
          sortable: false,
          value: "id",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "Company",
          value: "trading_as",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "ADDRESS",
          value: "business_address",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "PHONE_NUMBER",
          value: "telephone",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Reg Date",
          value: "period",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        // {
        //   text: "Document",
        //   value: "invoice",
        //   class: "text-secondary font-weight-bolder opacity-7",
        // },
      ],
    };
  },
  created () {
    // this.getCompanies()
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {
    ...mapState(['base_url']),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    pages() {
      return this.pagination.rowsPerPage
          ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
          : 0;
    },
  },
  methods: {
    getCompanies(){
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/auth/get-organisations/', { headers: { Authorization: `Bearer ${JWTToken}` } } )
          .then(res => {
            if (res.status === 200) {
              this.returns = res.data
              console.log(this.returns)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
    PreviewFile(){
      this.overlay = true
      let file = this.files[0]
      let FileExt = file.name.split('.')[1]
      console.log(FileExt)
      if(FileExt ==='xlsx') {
        const reader = new FileReader();
        const that = this
        reader.onload = function (e) {
          const data = e.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          workbook.SheetNames.forEach(function (sheetName) {
            // Here is your object
            const XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
            const json_object = JSON.stringify(XL_row_object);
            XL_row_object.forEach((node) => node.registration_number = node.CompanyReg)
            XL_row_object.forEach((node) => node.date_of_registration = that.sanitizeDate(node.RegistrationDate))
            XL_row_object.forEach((node) => node.trading_as = node.CompanyName)
            XL_row_object.forEach((node) => node.business_address = node.Address)
            XL_row_object.forEach((node) => node.contact_name = node.ContactName)
            XL_row_object.forEach((node) => node.telephone = node.TelephoneNumber)
            XL_row_object.forEach((node) => node.email = node.Email)
            XL_row_object.forEach((node) => node.officer = node.Officer)
            XL_row_object.forEach((node) => node.status = node.Status)
            XL_row_object.forEach((node) => node.region = node.Region.trim())
            XL_row_object.forEach((node) => node.date_of_cancelation =  that.sanitizeDate(node.CancellationDate))
            that.companies = XL_row_object;
            console.log(that.companies)
            return json_object;
          })

        };
        reader.onerror = function (ex) {
          console.log(ex);
        };
        reader.readAsBinaryString(file);
      }
      else{
        this.overlay = false;
        this.valid = false;
        this.errorUpload2 = true;
      }
      this.overlay = false
    },
    async UploadOrgs() {
      this.overlay = true;
      this.companyUpload = false;
      await new Promise(resolve => setTimeout(resolve, 2000));
      let JWTToken = this.$store.getters.accessToken;
      console.log(this.$store.getters.accessToken);
      const config = {
        method: "post",
        url: this.base_url + "/auth/add-companies/",
        headers: {
          // Authorization: `Bearer ${JWTToken}`,
          'Content-Type': 'application/json',
          // 'Content-Type': 'multipart/form-data'
        },
        data: this.companies
      };

      axios(config)
          .then((response) => {
            if (response.status === 201) {
              this.overlay = false;
              this.successDialog = true
            }
          })
          .catch((error) => {
            if (error.status === 400) {
              this.errorDialog = true
              this.overlay = false;
            }
            else {
              this.errorDialog = true
              this.overlay = false;
            }
          });

    },
    sanitizeDate(date){
      let d = moment(date, "DD.MM.YYYY");

      if (d.isValid() && len(date) === 10){
        let dateArray = date.split('.')
        return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0]
      }
      else if (date === undefined){
        return null
      }
      else if (date === null){
        return null
      }
      else{
        return null
      }
    },
    clear(){
      this.companies = []
      this.overlay = false
      this.companyUpload = true
      this.files = []
    },
    goTo(){
      this.$router.push("/admin-companies");
    }
  },
};
</script>
